class DrawerModal extends HTMLElement {
  constructor() {
    super();
  
    
    this.modalContainer = this.querySelector('.modal-container') || document.querySelector('.modal-container.search-modal');
   
    this.openModal = this.querySelector('.modal-button');
    
    this.closeModal = this.querySelector('.close-modal');
    this.lists = this.modalContainer.querySelectorAll(".nav__item-submenu");

    if(this.modalContainer.classList.contains("navigation_menu")){
      
      var elements = getFocusableElements(this.modalContainer);
      var last = elements[elements.length - 1];
      var first = elements[0];
      this.openModal.addEventListener('keydown', (event)=> event.code.toUpperCase() === 'ENTER' && this.openNavigation(event,first,last));
      this.modalContainer.addEventListener('keydown', (event) => event.target === last && !event.shiftKey && this.closeNavigation(event));
      this.modalContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.closeNavigation(event));
      this.openModal.addEventListener('blur', (event) => {
          const nextFocusedElement = event.relatedTarget;        
          if (!this.openModal.parentElement.contains(nextFocusedElement)) {
            this.closeNavigation(event)
          }
        });
    

    }else{
      var elements = getFocusableElements(this.modalContainer);
      
      const searchInput = this.modalContainer.querySelector('input[aria-owns="predictive-search-results"]');
     
      
      if(searchInput) {
        searchInput.addEventListener("change", (event) => trapFocus(
                this.modalContainer.querySelector('[tabindex="-1"]'),
                this.modalContainer.querySelector('a') || this.modalContainer.querySelector('[tabindex="-1"]')
              )
        );
      }

      
      this.modalContainer.addEventListener(
        'keyup',
        (event) =>  event.code.toUpperCase() === 'ESCAPE' && this.close()
      ); 
      this.modalContainer.addEventListener(
        'keydown',
        (event) =>  event.code.toUpperCase() === 'ENTER' && event.target.tagName === 'LABEL' && this.selectLabel(event)
      ); 
      this.openModal && this.openModal.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );
    }
    
  }

  open(event) {
    if( this.modalContainer.classList.contains("menu-drawer")){
      trapFocus(
      this.modalContainer.querySelector('[tabindex="-1"]'),
      this.modalContainer.querySelector('a') || this.modalContainer.querySelector('.close-modal')     
    );

    }else{
      trapFocus(
      this.modalContainer.querySelector('[tabindex="-1"]'),
      this.modalContainer.querySelector('input:not([type="hidden"])') || this.modalContainer.querySelector('[tabindex="-1"]')
    );
    }
    
  }

  close(focusToggle = true) {
    const type = this.dataset.type;

    if (type === 'quickview') {
      window.dispatchEvent(new CustomEvent('close-quick-view'));
      return;
    }

    if (type === 'sizechart') {
      window.dispatchEvent(new CustomEvent('close-size-chart'));
      return;
    }

    if (this.modalContainer.id === 'products-filters-drawer') {
      window.dispatchEvent(new CustomEvent('close-filter'));
      return;
    }

    if (this.modalContainer.classList.contains('cart-drawer')) {
      window.dispatchEvent(new CustomEvent('close-cart'));
      return;
    }

    const modalData = this.modalContainer._x_dataStack?.[0];
    const closeMethod = modalData?.closeMenu || modalData?._closeSearch || modalData?.close;

    if (typeof closeMethod === 'function') {
      closeMethod.call(modalData);
    } else if (modalData && 'openDrawer' in modalData) {
      modalData.openDrawer = false;
      document.body.style.overflow = 'auto';
    }

    removeTrapFocus(focusToggle ? this.openModal : null);
  }

  openNavigation(event,first){
    event.preventDefault();
    if (event.key === 'Enter') { 
        
      this.modalContainer.classList.add('menu--open');
      
      // Handle Enter key press here
      if (first) {
        first.focus();
      }
    }
  }
  
  closeNavigation(event){
    event.preventDefault();
    this.modalContainer.classList.remove('menu--open');
  }

  isOpen() {
    return this.modalContainer.hasAttribute('open');
  }


  selectLabel(event){
    const inputId = event.target.getAttribute('for');
    const input = document.getElementById(inputId);

    if (input) {
      input.click();
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

}

customElements.define('drawer-modal', DrawerModal);
